<template>
  <div class="modal" ref="preview">
    <div class="modal-background" @click="hidePreview"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <span class="modal-card-title">Aperçu des produits dans le comparateur</span>
      </header>
      <section class="modal-card-body">
        <div v-if="array.length === 0">Aucun produit n'a été ajouté.</div>
        <template v-else>
          <SkeletonLoading v-if="loading">
            <div class="cppreview__grid">
              <div v-for="i in array.length" :key="i" class="loading">
                <SkeletonRectangle :width="150" :height="25"/>
                <SkeletonRectangle :width="150" :height="150"/>
                <SkeletonRectangle :width="150" :height="20"/>
                <SkeletonCircle/>
              </div>
            </div>
          </SkeletonLoading>
          <template v-else>
            <div class="cppreview__grid">
              <div class="cpreview__pcard" v-for="(product,key) in products">
                <h4>{{ product.name }}</h4>
                <div v-html="product.img"></div>
                <p>{{ product.price }} €</p>
                <button class="cpreview__remove" title="Retirer du comparateur" @click="remove(key)"
                  type="button">&times;
                </button>
              </div>
            </div>
          </template>
        </template>
      </section>
      <footer class="modal-card-foot">
        <div>
          <button class="button" @click="hidePreview">Continuer la navigation</button>
        </div>
        <div>
          <button class="button is-success" @click="empty">Vider le comparateur</button>
          <a class="button" href="/comparateur/">Comparer maintenant</a>
        </div>
      </footer>
    </div>
    <button @click="hidePreview" type="button" class="modal-close is-large" aria-label="close">&times</button>
  </div>
</template>

<script>
import SkeletonRectangle from "../../skeletons/SkeletonRectangle";
import SkeletonLoading from "../../skeletons/SkeletonLoading";
import SkeletonCircle from "../../skeletons/SkeletonCircle";

export default {
  name: "ComparateurPreview",
  components: {SkeletonCircle, SkeletonLoading, SkeletonRectangle},
  data() {
    return {
      array: [],
      products: [],
      loading: true,
      lastLoaded: [],
    }
  },
  created() {
    this.getLocalStorage();
  },
  methods: {
    getLocalStorage() {
      if (null !== localStorage.getItem('comparateur')) {
        this.array = JSON.parse(localStorage.getItem('comparateur'));
      }
    },
    displayPreview() {
      this.getLocalStorage();
      if (this.lastLoaded !== JSON.stringify(this.array)) {
        this.lastLoaded = JSON.stringify(this.array);
        // console.log('different');
        this.products = [];
        this.loading = true;

        window.$api.post(`g2r/v1/comparateur/preview`, {data: this.array})
          .then(response => response.data)
          .then(data => {
            this.loading = false;
            this.products = data;
          })
      }
      // else {
      //   console.log('same')
      // }
      this.$refs.preview.classList.add('is-active');
    },
    hidePreview() {
      this.$refs.preview.classList.remove('is-active');
    },
    remove(key) {
      this.array = this.array.slice(0, key).concat(this.array.slice(key + 1, this.array.length));
      this.products = this.products.slice(0, key).concat(this.products.slice(key + 1, this.products.length));
      this.saveLocalStorage();
    },
    empty() {
      this.array = [];
      this.products = [];
      this.saveLocalStorage();
      setTimeout(() => this.hidePreview(), 1000);
    },
    saveLocalStorage() {
      localStorage.setItem('comparateur', JSON.stringify(this.array));
      comparateurCountText.innerHTML = this.array.length.toString();
    },
  },
  // beforeMount() {
  //   console.log(window.$api)
  // }
}
</script>

<style scoped lang="scss">
@import '../../../../../../scss/variables';

.modal-card {
  padding: 0;
  font-size: 14px;

  header {
    text-align: center;
  }

  .modal-card-body {
    .cppreview__grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
      grid-column-gap: 2%;

      .loading ::v-deep svg {
        display: block;
        margin: 0 auto 1rem;

        &:first-child {
          margin-top: -2rem;
          margin-bottom: 3.3rem;
        }

        &:nth-child(3) {
          margin-bottom: .5rem;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }

      .cpreview__pcard {
        text-align: center;

        .cpreview__remove {
          background-color: $g2r-header-bg;
          font-size: 2rem;
          padding: 5px 6px 6px;
          line-height: .5;
          border-radius: 50%;
        }

        h4 {
          height: 48px;
          color: $green;
          text-transform: uppercase;
        }

        p {
          margin-bottom: 0;
        }
      }
    }
  }

  footer {
    justify-content: space-between;
    padding: 1rem 2rem;

    button, .button {
      padding: 1rem;
      font-size: 12px;
      line-height: 1;
    }
  }
}
</style>
